import { ConquestMarketplaceConfig } from '../campaigns/table-column/ConquestData';

export type AcquirePermissionsData = {
  ftIsMarketplaceAvailable: boolean;
  hasAtLeasOneCqSub: boolean;
  hasIAPackage: boolean;
  hasAcquirePermission: boolean;
  hasMarketplacePermission: boolean;
  isAutomotiveUser: boolean;
};

export class AcquirePermissions {
  private ftIsMarketplaceAvailable: boolean;
  private hasAtLeasOneCqSub: boolean;
  private hasIAPackage: boolean;
  private hasAcquirePermission: boolean;
  private hasMarketplacePermission: boolean;
  private isAutomotiveUser: boolean;

  constructor(data: AcquirePermissionsData) {
    this.ftIsMarketplaceAvailable = data.ftIsMarketplaceAvailable;
    this.hasAtLeasOneCqSub = data.hasAtLeasOneCqSub;
    this.hasIAPackage = data.hasIAPackage;
    this.hasAcquirePermission = data.hasAcquirePermission;
    this.hasMarketplacePermission = data.hasMarketplacePermission;
    this.isAutomotiveUser = data.isAutomotiveUser;
  }

  private legacyDisplayAcquireInMainMenu = () => {
    if (!this.hasIAPackage) {
      return true;
    } else {
      return (this.hasIAPackage || this.hasAcquirePermission) && this.hasAtLeasOneCqSub;
    }
  };

  private getLegacyPermissions = () => ({
    isPortfolioAvailable:
      (this.hasIAPackage || this.hasAcquirePermission) && this.hasAtLeasOneCqSub,
    displayAcquireInMainMenu: this.legacyDisplayAcquireInMainMenu(),
  });

  private displayAcquireInMainMenu = () => {
    if (!this.ftIsMarketplaceAvailable) {
      return this.getLegacyPermissions().displayAcquireInMainMenu;
    }

    if (this.isAutomotiveUser) {
      return true;
    }

    if (!this.hasAtLeasOneCqSub) {
      if (this.hasIAPackage) {
        return false;
      }

      return this.hasMarketplacePermission;
    }

    return this.hasAcquirePermission || this.hasMarketplacePermission;
  };

  private displayProspect = () => {
    if (!this.ftIsMarketplaceAvailable) {
      return this.getLegacyPermissions().isPortfolioAvailable;
    }

    if (this.isAutomotiveUser) {
      if (this.hasAtLeasOneCqSub) {
        return true;
      }
    }

    return this.hasAcquirePermission && this.hasAtLeasOneCqSub;
  };

  private displayOpportunityMap = () => {
    if (this.isAutomotiveUser || !this.ftIsMarketplaceAvailable) {
      return true;
    }

    if (this.hasIAPackage && !this.hasAtLeasOneCqSub) {
      return false;
    }

    return this.hasMarketplacePermission;
  };

  private editOpportunityMap = () => {
    if (this.isAutomotiveUser) {
      return true;
    }

    return false;
  };

  private displayMarketplace = () => {
    if (!this.ftIsMarketplaceAvailable) {
      return false;
    }

    if (this.isAutomotiveUser) {
      return true;
    }

    if (this.hasIAPackage && !this.hasAtLeasOneCqSub) {
      return false;
    }

    return this.hasMarketplacePermission;
  };

  private editMarketplace = (marketplaceConfig: ConquestMarketplaceConfig) => {
    if (!this.ftIsMarketplaceAvailable) {
      return false;
    }

    if (this.isAutomotiveUser) {
      if (marketplaceConfig == null) {
        return false;
      }

      return marketplaceConfig.eligibleToEdit && marketplaceConfig.lockPeriodEnd == null;
    }

    return false;
  };

  private routePermissions = () => {
    if (!this.ftIsMarketplaceAvailable) {
      return (
        !this.hasIAPackage ||
        (this.hasAtLeasOneCqSub && (this.hasIAPackage || this.hasAcquirePermission))
      );
    }

    return this.displayMarketplace() || this.displayProspect() || this.displayOpportunityMap();
  };

  public getPermissions = () => ({
    displayProspect: this.displayProspect(),
    displayAcquireInMainMenu: this.displayAcquireInMainMenu(),
    displayOpportunityMap: this.displayOpportunityMap(),
    editOpportunityMap: this.editOpportunityMap(),
    displayMarketplace: this.displayMarketplace(),
    editMarketplace: this.editMarketplace,
    routePermissions: this.routePermissions(),
  });
}
